import { InfoAlert } from '@/General/InfoAlert'
import { TextLink } from '@/General/TextLink'
import type { CommunityQuestionFeedback } from '@/lib/communityQuestionFeedback'

export function ModerationFeedback({
  feedback,
}: {
  feedback: CommunityQuestionFeedback | null
}) {
  if (!feedback) return null

  return (
    <div
      id="community-post-feedback"
      role="alert"
      aria-label="Post feedback"
      aria-atomic="true"
    >
      <InfoAlert
        variant="warning"
        title={
          feedback.kind === 'guidelines'
            ? 'We believe this post does not follow our community guidelines'
            : "We couldn't check your post just now"
        }
      >
        {feedback.messages.length > 0 ? (
          <ul className="list-disc space-y-2 pl-5">
            {feedback.messages.map(message => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        ) : null}
        <p className={feedback.messages.length > 0 ? 'mt-3' : ''}>
          {feedback.kind === 'guidelines'
            ? "Your post hasn't been published. Your text is still below, so you can edit it and try again."
            : "Your post hasn't been published, and your text is still below. Please try again in a moment."}
        </p>
        <p className="mt-3">
          {feedback.kind === 'guidelines'
            ? "If you need help or think we've misunderstood your post, please "
            : 'If you need a hand, please '}
          <TextLink href="/contact-us/">contact our support team</TextLink>.{' '}
          We’re happy to help.
        </p>
      </InfoAlert>
    </div>
  )
}
